(() => {
  const caSod005NavRoot = document.querySelector('[data-ca-sod-005-nav-desktop]')
  if (!caSod005NavRoot) return

  const caSod005NavStorageProductsKey = 'SS:ca-sod-005-nav-blacklist-products'
  const caSod005NavStorageZipKey = 'SS:ca-sod-005-nav-blacklist-zip'
  const caSod005NavDetailsList = [
    ...caSod005NavRoot.querySelectorAll('[data-ca-sod-005-nav-details]')
  ]

  const caSod005NavStorageGet = (caSod005NavKey) => {
    try {
      return window.localStorage.getItem(caSod005NavKey)
    } catch (caSod005NavError) {
      return null
    }
  }

  const caSod005NavStorageSet = (caSod005NavKey, caSod005NavValue) => {
    try {
      window.localStorage.setItem(caSod005NavKey, caSod005NavValue)
    } catch (caSod005NavError) {
      // Navigation can still work from in-memory fetch result.
    }
  }

  const caSod005NavParseBlacklistProducts = (caSod005NavValue) => {
    let caSod005NavProducts = caSod005NavValue
    if (typeof caSod005NavValue === 'string') {
      const caSod005NavTrimmedValue = caSod005NavValue.trim()
      if (!caSod005NavTrimmedValue) {
        throw new Error('SOD 005 nav availability blacklist payload is empty')
      }

      try {
        caSod005NavProducts = JSON.parse(caSod005NavTrimmedValue)
      } catch (caSod005NavError) {
        throw new Error('SOD 005 nav availability blacklist payload is not valid JSON')
      }
    }

    if (
      caSod005NavProducts &&
      Object.prototype.hasOwnProperty.call(caSod005NavProducts, 'products')
    ) {
      caSod005NavProducts = caSod005NavProducts.products
    }

    if (!Array.isArray(caSod005NavProducts)) {
      throw new Error('SOD 005 nav availability blacklist payload is not an array')
    }

    return caSod005NavProducts
      .map((caSod005NavProductId) => String(caSod005NavProductId || '').trim())
      .filter(Boolean)
  }

  const caSod005NavGetZip = () => {
    const caSod005NavStateZip = window.Scoutside?.LocationState?.zipcode

    return String(caSod005NavStateZip || '').trim()
  }

  const caSod005NavGetCachedBlacklist = (caSod005NavZip) => {
    const caSod005NavCachedZip = caSod005NavStorageGet(caSod005NavStorageZipKey)
    if (!caSod005NavZip || caSod005NavCachedZip !== caSod005NavZip) return null

    const caSod005NavCachedProducts = caSod005NavStorageGet(caSod005NavStorageProductsKey)
    if (caSod005NavCachedProducts === null) return null

    try {
      return caSod005NavParseBlacklistProducts(caSod005NavCachedProducts)
    } catch (caSod005NavError) {
      return null
    }
  }

  const caSod005NavFetchBlacklist = async (caSod005NavZip) => { for(let n=0;n<40&&!window.Scoutside?.ZipBlacklist?.listForZip;n++)await new Promise(r=>setTimeout(r,50));const L=window.Scoutside?.ZipBlacklist?.listForZip?.(caSod005NavZip);if(L){caSod005NavStorageSet(caSod005NavStorageProductsKey,JSON.stringify(L));caSod005NavStorageSet(caSod005NavStorageZipKey,caSod005NavZip);return L}
    const caSod005NavApiUrl = window.Scoutside?.shop?.zipBlacklistApiUrl
    if (!caSod005NavZip || !caSod005NavApiUrl) {
      throw new Error('SOD 005 nav availability missing ZIP or blacklist API URL')
    }

    const caSod005NavBaseUrl = String(caSod005NavApiUrl).replace(/\/$/, '')
    const caSod005NavResponse = await fetch(
      `${caSod005NavBaseUrl}/${encodeURIComponent(caSod005NavZip)}`,
      { method: 'GET' }
    )

    if (!caSod005NavResponse.ok) {
      throw new Error('SOD 005 nav availability blacklist request failed')
    }

    const caSod005NavData = await caSod005NavResponse.text()
    const caSod005NavProducts = caSod005NavParseBlacklistProducts(caSod005NavData)

    caSod005NavStorageSet(caSod005NavStorageProductsKey, JSON.stringify(caSod005NavProducts))
    caSod005NavStorageSet(caSod005NavStorageZipKey, caSod005NavZip)

    return caSod005NavProducts
  }

  let caSod005NavInFlightZip = ''
  let caSod005NavInFlightPromise = null

  const caSod005NavGetBlacklistForZip = (caSod005NavZip) => {
    if (caSod005NavInFlightPromise && caSod005NavInFlightZip === caSod005NavZip) {
      return caSod005NavInFlightPromise
    }

    const caSod005NavPromise = caSod005NavFetchBlacklist(caSod005NavZip).finally(() => {
      if (caSod005NavInFlightPromise !== caSod005NavPromise) return

      caSod005NavInFlightZip = ''
      caSod005NavInFlightPromise = null
    })

    caSod005NavInFlightZip = caSod005NavZip
    caSod005NavInFlightPromise = caSod005NavPromise

    return caSod005NavPromise
  }

  const caSod005NavSetHidden = (caSod005NavElement, caSod005NavIsHidden) => {
    if (!caSod005NavElement) return

    caSod005NavElement.hidden = caSod005NavIsHidden
    caSod005NavElement.setAttribute(
      'data-ca-sod-005-nav-hidden',
      caSod005NavIsHidden ? 'true' : 'false'
    )
  }

  const caSod005NavGetProductId = (caSod005NavWrapper) => {
    const caSod005NavProductElement = caSod005NavWrapper.querySelector(
      '[data-ca-sod-005-nav-product-id]'
    )
    const caSod005NavProductId =
      caSod005NavProductElement?.getAttribute('data-ca-sod-005-nav-product-id') ||
      caSod005NavWrapper.getAttribute('data-ca-sod-005-nav-product-id')

    return String(caSod005NavProductId || '').trim()
  }

  const caSod005NavProductWrappers = (caSod005NavDetails) => [
    ...caSod005NavDetails.querySelectorAll('[data-ca-sod-005-nav-product-wrapper]')
  ]

  const caSod005NavVisibleProductWrappers = (caSod005NavDetails) =>
    caSod005NavProductWrappers(caSod005NavDetails).filter((caSod005NavWrapper) => {
      return caSod005NavGetProductId(caSod005NavWrapper) && !caSod005NavWrapper.hidden
    })

  const caSod005NavVisibleMenuLinks = (caSod005NavDetails) => [
    ...caSod005NavDetails.querySelectorAll('.ca-sod-005-nav-megamenu__link')
  ].filter((caSod005NavLink) => !caSod005NavLink.closest('[hidden]'))

  const caSod005NavSetTopProductsCtaOnly = (caSod005NavTopProducts, caSod005NavIsCtaOnly) => {
    if (!caSod005NavTopProducts) return

    caSod005NavTopProducts.classList.toggle(
      'ca-sod-005-nav-megamenu__top-products--cta-only',
      caSod005NavIsCtaOnly
    )

    const caSod005NavEyebrow = caSod005NavTopProducts.querySelector(
      '[data-ca-sod-005-nav-top-products-eyebrow]'
    )
    const caSod005NavFallbackHeading =
      caSod005NavTopProducts.getAttribute('data-ca-sod-005-nav-top-products-heading') || ''
    const caSod005NavCtaOnlyHeading =
      caSod005NavTopProducts.getAttribute('data-ca-sod-005-nav-megamenu-title') || ''
    const caSod005NavHeading =
      caSod005NavIsCtaOnly && caSod005NavCtaOnlyHeading
        ? caSod005NavCtaOnlyHeading
        : caSod005NavFallbackHeading

    const caSod005NavEmptyCopy = caSod005NavTopProducts.querySelector(
      '[data-ca-sod-005-nav-top-products-empty-copy]'
    )

    if (caSod005NavEyebrow) caSod005NavEyebrow.textContent = caSod005NavHeading
    if (caSod005NavHeading) caSod005NavTopProducts.setAttribute('aria-label', caSod005NavHeading)
    if (caSod005NavEmptyCopy) caSod005NavSetHidden(caSod005NavEmptyCopy, !caSod005NavIsCtaOnly)
  }

  const caSod005NavSetDetailsAvailability = (
    caSod005NavDetails,
    caSod005NavState,
    caSod005NavEnabled
  ) => {
    caSod005NavDetails.setAttribute('data-ca-sod-005-nav-availability-state', caSod005NavState)
    caSod005NavDetails.setAttribute(
      'data-ca-sod-005-nav-availability-enabled',
      caSod005NavEnabled ? 'true' : 'false'
    )

    const caSod005NavItem = caSod005NavDetails.closest('[data-ca-sod-005-nav-primary-item]')
    if (caSod005NavItem) {
      caSod005NavItem.setAttribute('data-ca-sod-005-nav-availability-state', caSod005NavState)
      caSod005NavItem.setAttribute(
        'data-ca-sod-005-nav-availability-enabled',
        caSod005NavEnabled ? 'true' : 'false'
      )
    }

    if (!caSod005NavEnabled) caSod005NavDetails.removeAttribute('open')
  }

  const caSod005NavResetVisibleElements = (caSod005NavDetails) => {
    caSod005NavDetails
      .querySelectorAll(
        [
          '[data-ca-sod-005-nav-product-wrapper]',
          '.ca-sod-005-nav-megamenu__top-products',
          '.ca-sod-005-nav-megamenu__featured',
          '.ca-sod-005-nav-megamenu__columns',
          '.ca-sod-005-nav-megamenu__column'
        ].join(',')
      )
      .forEach((caSod005NavElement) => caSod005NavSetHidden(caSod005NavElement, false))

    caSod005NavDetails
      .querySelectorAll('.ca-sod-005-nav-megamenu__top-products')
      .forEach((caSod005NavTopProducts) =>
        caSod005NavSetTopProductsCtaOnly(caSod005NavTopProducts, false)
      )
  }

  const caSod005NavLimitTopProducts = (caSod005NavDetails) => {
    const caSod005NavTopProductCandidates = [
      ...caSod005NavDetails.querySelectorAll('[data-ca-sod-005-nav-top-product-candidate]')
    ]
    let caSod005NavVisibleTopProductCount = 0

    caSod005NavTopProductCandidates.forEach((caSod005NavCandidate) => {
      const caSod005NavProductId = caSod005NavGetProductId(caSod005NavCandidate)

      if (!caSod005NavProductId || caSod005NavCandidate.hidden) {
        caSod005NavSetHidden(caSod005NavCandidate, true)
        return
      }

      caSod005NavVisibleTopProductCount += 1
      caSod005NavSetHidden(caSod005NavCandidate, caSod005NavVisibleTopProductCount > 3)
    })

    const caSod005NavTopProducts = caSod005NavDetails.querySelector(
      '.ca-sod-005-nav-megamenu__top-products'
    )
    if (caSod005NavTopProducts && caSod005NavTopProductCandidates.length > 0) {
      const caSod005NavHasTopProductsCta = Boolean(
        caSod005NavTopProducts.querySelector('.ca-sod-005-nav-megamenu__button')
      )
      const caSod005NavIsTopProductsCtaOnly =
        caSod005NavVisibleTopProductCount === 0 && caSod005NavHasTopProductsCta

      caSod005NavSetTopProductsCtaOnly(
        caSod005NavTopProducts,
        caSod005NavIsTopProductsCtaOnly
      )
      caSod005NavSetHidden(
        caSod005NavTopProducts,
        caSod005NavVisibleTopProductCount === 0 && !caSod005NavHasTopProductsCta
      )
    }
  }

  const caSod005NavHasVisibleTopProductsCta = (caSod005NavDetails) =>
    Boolean(
      caSod005NavDetails.querySelector(
        '.ca-sod-005-nav-megamenu__top-products:not([hidden]) .ca-sod-005-nav-megamenu__button'
      )
    )

  const caSod005NavCollapseProductGroups = (caSod005NavDetails) => {
    const caSod005NavFeatured = caSod005NavDetails.querySelector(
      '.ca-sod-005-nav-megamenu__featured'
    )
    if (caSod005NavFeatured) {
      const caSod005NavFeaturedProducts = [
        ...caSod005NavFeatured.querySelectorAll('[data-ca-sod-005-nav-product-wrapper]')
      ]
      if (caSod005NavFeaturedProducts.length > 0) {
        caSod005NavSetHidden(
          caSod005NavFeatured,
          caSod005NavFeaturedProducts.every((caSod005NavProduct) => caSod005NavProduct.hidden)
        )
      }
    }

    const caSod005NavColumns = [
      ...caSod005NavDetails.querySelectorAll('.ca-sod-005-nav-megamenu__column')
    ]
    caSod005NavColumns.forEach((caSod005NavColumn) => {
      caSod005NavSetHidden(
        caSod005NavColumn,
        caSod005NavVisibleMenuLinks(caSod005NavColumn).length === 0
      )
    })

    const caSod005NavColumnsWrapper = caSod005NavDetails.querySelector(
      '.ca-sod-005-nav-megamenu__columns'
    )
    if (caSod005NavColumnsWrapper && caSod005NavColumns.length > 0) {
      caSod005NavSetHidden(
        caSod005NavColumnsWrapper,
        caSod005NavColumns.every((caSod005NavColumn) => caSod005NavColumn.hidden)
      )
    }
  }

  const caSod005NavApplyBlacklist = (caSod005NavProducts) => {
    const caSod005NavBlacklist = new Set(caSod005NavProducts)

    caSod005NavDetailsList.forEach((caSod005NavDetails) => {
      const caSod005NavIsGated =
        caSod005NavDetails.getAttribute('data-ca-sod-005-nav-availability-gated') === 'true'

      caSod005NavResetVisibleElements(caSod005NavDetails)

      if (!caSod005NavIsGated) {
        caSod005NavSetDetailsAvailability(caSod005NavDetails, 'ready', true)
        return
      }

      caSod005NavProductWrappers(caSod005NavDetails).forEach((caSod005NavWrapper) => {
        const caSod005NavProductId = caSod005NavGetProductId(caSod005NavWrapper)
        const caSod005NavMissingRequiredProductId =
          caSod005NavWrapper.hasAttribute('data-ca-sod-005-nav-product-id-required') &&
          !caSod005NavProductId

        caSod005NavSetHidden(
          caSod005NavWrapper,
          caSod005NavMissingRequiredProductId || caSod005NavBlacklist.has(caSod005NavProductId)
        )
      })

      caSod005NavLimitTopProducts(caSod005NavDetails)
      caSod005NavCollapseProductGroups(caSod005NavDetails)

      const caSod005NavHasVisibleMenuContent =
        caSod005NavVisibleProductWrappers(caSod005NavDetails).length > 0 ||
        caSod005NavVisibleMenuLinks(caSod005NavDetails).length > 0 ||
        caSod005NavHasVisibleTopProductsCta(caSod005NavDetails)

      caSod005NavSetDetailsAvailability(
        caSod005NavDetails,
        caSod005NavHasVisibleMenuContent ? 'ready' : 'empty',
        caSod005NavHasVisibleMenuContent
      )
    })
  }

  const caSod005NavSetPending = () => {
    caSod005NavDetailsList.forEach((caSod005NavDetails) => {
      const caSod005NavIsGated =
        caSod005NavDetails.getAttribute('data-ca-sod-005-nav-availability-gated') === 'true'

      if (caSod005NavIsGated) {
        caSod005NavSetDetailsAvailability(caSod005NavDetails, 'pending', false)
      } else {
        caSod005NavResetVisibleElements(caSod005NavDetails)
        caSod005NavSetDetailsAvailability(caSod005NavDetails, 'ready', true)
      }
    })
  }

  const caSod005NavSetError = () => {
    caSod005NavDetailsList.forEach((caSod005NavDetails) => {
      const caSod005NavIsGated =
        caSod005NavDetails.getAttribute('data-ca-sod-005-nav-availability-gated') === 'true'

      if (caSod005NavIsGated) {
        caSod005NavSetDetailsAvailability(caSod005NavDetails, 'error', false)
      } else {
        caSod005NavSetDetailsAvailability(caSod005NavDetails, 'ready', true)
      }
    })
  }

  let caSod005NavRefreshRequestId = 0

  const caSod005NavRefresh = async () => {
    const caSod005NavRequestId = caSod005NavRefreshRequestId + 1
    caSod005NavRefreshRequestId = caSod005NavRequestId

    caSod005NavSetPending()

    const caSod005NavZip = caSod005NavGetZip()
    if (!caSod005NavZip) return

    const caSod005NavCachedProducts = caSod005NavGetCachedBlacklist(caSod005NavZip)
    if (caSod005NavCachedProducts !== null) {
      caSod005NavApplyBlacklist(caSod005NavCachedProducts)
      return
    }

    try {
      const caSod005NavProducts = await caSod005NavGetBlacklistForZip(caSod005NavZip)
      if (caSod005NavRequestId !== caSod005NavRefreshRequestId) return

      caSod005NavApplyBlacklist(caSod005NavProducts)
    } catch (caSod005NavError) {
      if (caSod005NavRequestId !== caSod005NavRefreshRequestId) return

      console.error(caSod005NavError)
      caSod005NavSetError()
    }
  }

  let caSod005NavRefreshScheduled = false

  const caSod005NavScheduleRefresh = () => {
    if (caSod005NavRefreshScheduled) return

    caSod005NavRefreshScheduled = true
    const caSod005NavRunScheduledRefresh = () => {
      caSod005NavRefreshScheduled = false
      caSod005NavRefresh()
    }

    if (typeof window.queueMicrotask === 'function') {
      window.queueMicrotask(caSod005NavRunScheduledRefresh)
      return
    }

    Promise.resolve().then(caSod005NavRunScheduledRefresh)
  }

  document.addEventListener('setZipCode', caSod005NavScheduleRefresh)
  caSod005NavRefresh()

  window.Scoutside = window.Scoutside || {}
  window.Scoutside.caSod005NavAvailability = {
    refresh: caSod005NavRefresh
  }
})()
